import { CodeSurfer } from "code-surfer";
import { Appear, Notes, Image, Split, Head } from 'mdx-deck';
import ImageProcessThinking from '/static/images/process-thinking.jpg';
import ImageObjective from '/static/objective.png';
import ImageContinousImprovement from '/static/images/ContinuousImprovement.png';
import ImageToolChain from '/static/images/ToolChain.png';
import ImageTableMaturity from '/static/images/table-maturity.png';
import ImageScrumFiveMinutes from '/static/images/scrum5minutes.jpg';
import ImageScrum from '/static/images/scrum.png';
import ImageScrumGoals from '/static/images/scrumgoals.png';
import ImageDevOps from '/static/images/devops.png';
import ImageDevSecOps from '/static/images/devsecops.png';
import ImageMainDevSecOps from '/static/images/MainDevSecOps.png';
import ImageCloudComputing from '/static/images/cloud-computing.png';
import ImageStepsPerformedHacker from '/static/steps-performed-by-hacker.png';
import 'prismjs/components/prism-shell-session';
import "prismjs/components/prism-hcl";
import "prismjs/components/prism-markdown";
import { FlexLayout, Video, BackgroundLayout } from "../../../../decks/components";
import Provider from "../../../../decks/provider";
import myTheme from "../../../../decks/theme";
import * as React from 'react';
export default {
  CodeSurfer,
  Appear,
  Notes,
  Image,
  Split,
  Head,
  ImageProcessThinking,
  ImageObjective,
  ImageContinousImprovement,
  ImageToolChain,
  ImageTableMaturity,
  ImageScrumFiveMinutes,
  ImageScrum,
  ImageScrumGoals,
  ImageDevOps,
  ImageDevSecOps,
  ImageMainDevSecOps,
  ImageCloudComputing,
  ImageStepsPerformedHacker,
  FlexLayout,
  Video,
  BackgroundLayout,
  Provider,
  myTheme,
  React
};